import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { WIDGET_TYPES, WIDGET_TYPE_LABELS } from '../../types/lawnTypes';

/**
 * "Add widget" menu. Only lists types that are not already on the grid, which is
 * what makes removing a widget recoverable.
 */
export default function WidgetPicker({ activeWidgetTypes, onAddWidget }) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const available = WIDGET_TYPES.filter((type) => !activeWidgetTypes.includes(type));

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleOutside = (event) => {
      if (!containerRef.current?.contains(event.target)) setIsOpen(false);
    };
    const handleEscape = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };

    document.addEventListener('mousedown', handleOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  return (
    <div className="lawn-widget-picker" ref={containerRef}>
      <button
        type="button"
        className="lawn-button-secondary"
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
        disabled={available.length === 0}
        title={available.length === 0 ? 'All widgets are already on the dashboard' : undefined}
      >
        <i className="ri-add-line" aria-hidden="true"></i> Add widget
      </button>

      {isOpen && available.length > 0 && (
        <ul className="lawn-widget-picker-menu">
          {available.map((type) => (
            <li key={type}>
              <button
                type="button"
                onClick={() => {
                  onAddWidget(type);
                  setIsOpen(false);
                }}
              >
                {WIDGET_TYPE_LABELS[type]}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

WidgetPicker.propTypes = {
  activeWidgetTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAddWidget: PropTypes.func.isRequired,
};
